export { default as Carousel } from './Carousel';
export { SimpleSlide } from './SimpleSlide';
export { carouselWithSimpleSlideAdapter, simpleSlideAdapter } from './adapters';
